import {observer} from 'mobx-react-lite';

import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';

import QuoteCarrierField from './QuoteCarrierField';
import CustomerQuoteFormStore from '../FormStore';

const QuoteBasicPermanentFields = observer(({state}: {state: CustomerQuoteFormStore}) => {
    const errors = state.getQuoteErrors();
    return (
        <Grid container spacing={3}>
            <Grid item xs={6}>
                <TextField
                    autoFocus
                    required
                    margin="normal"
                    label="Permanent Coverage"
                    defaultValue={state.quote.get('user_selected_perm_coverage')}
                    error={!!errors.user_selected_perm_coverage}
                    helperText={errors?.user_selected_perm_coverage}
                    onChange={(e) => {
                        state.setQuote('user_selected_perm_coverage', e.target.value);
                    }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    autoFocus
                    required
                    margin="normal"
                    label="Permanent Premium"
                    defaultValue={state.quote.get('user_selected_perm_premium')}
                    error={!!errors.user_selected_perm_premium}
                    helperText={errors?.user_selected_perm_premium}
                    onChange={(e) => {
                        state.setQuote('user_selected_perm_premium', e.target.value);
                    }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={6}>
                <QuoteCarrierField state={state} />
            </Grid>
        </Grid>
    );
});

export default QuoteBasicPermanentFields;
